import { t } from '@lingui/macro';
import { IconName } from 'noddi-ui-common';

enum SalesItem {
  // WC
  WheelChangeLargeCar = 7,
  WheelChangeSmallCar = 8,
  WheelChangeVan = 90,

  // Addon WC
  RimWashSmallCar = 9,
  RimWashLargeCar = 10,
  HelpToCarryTires = 25,

  // TH

  // New customer
  TireHotelNewCustomerSmallCar = 26,
  TireHotelNewCustomerLargeCar = 27,

  // Renewal
  TireHotelRenewal = 98,

  // TH cancel with WC
  TierHotelCancelHomeDeliveryAndWheelChange = 96,

  // TH cancel without WC
  TierHotelCancelHomeDelivery = 95,

  // TH addons
  TierHotelPickup = 51,

  // Random
  RepairOfPuncture = 8019,

  // Outside
  OutsideWashExtraDirty = 57,
  OutsideWashPlussLargeCar = 21,
  OutsideWashPlussSmallCar = 20,
  OutsideWashPremiumSmallCar = 22,
  OutsideWashPremiumLargeCar = 23,
  OutSideWashStandardLargeCar = 72,
  OutSideWashStandardSmallCar = 2,

  // Inside
  InsideWashExtraDirty = 29340,
  InsideWashPlussSmallCar = 16,
  InsideWashPlussLargeCar = 17,
  InsideWashPremiumSmallCar = 18,
  InsideWashPremiumLargeCar = 19,
  InsideWashVan = 110,
  InsideWashStandard = 1
}

export const getHardCodedSalesItems = (): {
  ids: number[];
  name: string;
  description: string;
  icon: IconName;
}[] => [
  {
    ids: [SalesItem.TierHotelPickup],
    name: t`Pickup of tires from another tire hotel`,
    description: t`We'll collect your tires from another tire hotel before bringing them to you`,
    icon: 'Home'
  },
  {
    ids: [SalesItem.HelpToCarryTires],
    name: t`Help to carry tires`,
    description: t`We'll help you carry your tires to and from the car`,
    icon: 'User'
  },
  {
    ids: [SalesItem.WheelChangeLargeCar, SalesItem.WheelChangeSmallCar, SalesItem.WheelChangeVan],
    name: t`Wheel change`,
    description: t`Place your tires on the ground, within 10 meters of the car. If not, there wil be an extra charge`,
    icon: 'WheelAngle'
  },
  {
    ids: [SalesItem.TireHotelNewCustomerSmallCar, SalesItem.TireHotelNewCustomerLargeCar],
    name: t`Tire hotel with wheel change`,
    description: t`We change your wheels and take care of the tires you're not using. Safely stored until next season`,
    icon: 'WheelAngle'
  },
  {
    ids: [SalesItem.TireHotelRenewal],
    name: t`Tire hotel renewal`,
    description: t`We bring your stored tires, change them, and store the ones we take off`,
    icon: 'WheelAngle'
  },
  {
    ids: [SalesItem.TierHotelCancelHomeDeliveryAndWheelChange],
    name: t`Home delivery and wheel change`,
    description: t`We'll bring your tires and do the wheel change right at your home to end the tire hotel contract`,
    icon: 'WheelAngle'
  },
  {
    ids: [SalesItem.RimWashSmallCar, SalesItem.RimWashLargeCar],
    name: t`Rim wash`,
    description: t`We wash with a steamer, so we have no need for access to water`,
    icon: 'Drop'
  },
  {
    ids: [SalesItem.RepairOfPuncture],
    name: t`Repair of puncture`,
    description: t`We'll fix it where you are parked, bringing all the necessary tools`,
    icon: 'WheelAngle'
  },
  {
    ids: [
      SalesItem.OutsideWashExtraDirty,
      SalesItem.OutsideWashPlussLargeCar,
      SalesItem.OutsideWashPlussSmallCar,
      SalesItem.OutsideWashPremiumSmallCar,
      SalesItem.OutsideWashPremiumLargeCar,
      SalesItem.OutSideWashStandardLargeCar,
      SalesItem.OutSideWashStandardSmallCar
    ],
    name: t`Outside car wash`,
    description: t`We wash with a steamer, so we have no need for access to water`,
    icon: 'Drop'
  },
  {
    ids: [
      SalesItem.InsideWashExtraDirty,
      SalesItem.InsideWashStandard,
      SalesItem.InsideWashPlussSmallCar,
      SalesItem.InsideWashPlussLargeCar,
      SalesItem.InsideWashPremiumSmallCar,
      SalesItem.InsideWashPremiumLargeCar,
      SalesItem.InsideWashVan
    ],
    name: t`Inside car wash`,
    description: t`Make sure the car is unlocked or that we have the key—we'll handle the rest`,
    icon: 'Drop'
  }
];
